import React, { useState } from 'react';
import 'tailwindcss/tailwind.css';
import "../../../App.css";
import { loginUser, loginModel, loginWithGoogle } from '../../http/Actions/AuthAction';
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(null);
  const [token, setToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const loginUsuario = { ...loginModel, Email: email, Password: password };

    try {
      const token = await loginUser(loginUsuario, setLoginError, setToken);
      localStorage.setItem('token', token);
      setToken(token);
      window.location.href = '/';
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const token = await loginWithGoogle(credentialResponse.credential, setLoginError, setToken);
      localStorage.setItem('token', token);
      window.location.href = '/';
    } catch (error) {
      console.error('Google login failed:', error);
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setLoginError('Error de autenticación con Google');
    setIsLoading(false);
  };

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-black relative"
      style={{
        backgroundImage: 'url(https://i.postimg.cc/rw3XpzPP/wallpaper.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-black bg-opacity-50"></div>
      
      <div className="z-10 max-w-md w-full">
        <div className="text-center mb-8">
          <h2 className="mt-6 text-4xl font-extrabold text-white">
            ¡Bienvenido de vuelta!
          </h2>
          <p className="mt-2 text-sm text-gray-300">
            Inicia sesión para ver los mejores shows de comedia en vivo
          </p>
        </div>
        
        <div className="bg-zinc-900 rounded-2xl shadow-xl overflow-hidden">
          <form className="p-8" onSubmit={handleSubmit}>
            {loginError && (
              <div className="bg-red-500/20 border border-red-500 text-red-100 px-4 py-3 rounded mb-6">
                <p className="font-bold">Error</p>
                <p className="text-sm">{loginError}</p>
              </div>
            )}
            
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-300">
                Email
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                             bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                             focus:ring-red-500 focus:border-transparent"
                  placeholder="tu@email.com"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="block text-sm font-medium text-gray-300">
                Contraseña
              </label>
              <div className="mt-1">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                             bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                             focus:ring-red-500 focus:border-transparent"
                  placeholder="•••••••••••"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center">
                <input
                  id="remember_me"
                  name="remember_me"
                  type="checkbox"
                  className="h-4 w-4 text-red-600 focus:ring-red-500 border-zinc-700 rounded bg-zinc-800"
                  disabled={isLoading}
                />
                <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-300">
                  Recuérdame
                </label>
              </div>

              <div className="text-sm">
                <a href="/forgotPassword" className="font-medium text-red-400 hover:text-red-300">
                  ¿Olvidaste tu contraseña?
                </a>
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent rounded-lg
                          text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                          focus:ring-red-500 font-bold transition duration-300 transform hover:scale-105 mb-4"
                disabled={isLoading}
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  {isLoading ? (
                    <svg className="animate-spin h-5 w-5 text-red-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    <svg className="h-5 w-5 text-red-400 group-hover:text-red-300" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </span>
                {isLoading ? 'Cargando...' : 'Iniciar Sesión'}
              </button>
            </div>
            
            <div className="mt-6 flex items-center">
              <div className="flex-grow border-t border-zinc-700"></div>
              <span className="flex-shrink mx-4 text-gray-400">O continúa con</span>
              <div className="flex-grow border-t border-zinc-700"></div>
            </div>
            
            <div className="mt-6 flex justify-center">
            {isLoading ? (
              <div className="flex items-center justify-center bg-blue-600 rounded-full h-10 w-40 text-white font-medium">
                <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Cargando...
              </div>
            ) : (
              <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={handleGoogleError}
                  shape="pill"
                  theme="filled_blue"
                  text="signin_with"
                  locale="es"
                  width="300"
                  disabled={isLoading}
                />
              </GoogleOAuthProvider>
            )}
            </div>
          </form>
          
          <div className="px-8 py-6 bg-zinc-950 text-center">
            <p className="text-gray-300">
              ¿Aún no tienes cuenta? <a href="/register" className="text-red-400 hover:underline font-bold">Regístrate ahora</a>
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Al iniciar sesión, tendrás acceso a todos nuestros livestreams de comedia. La risa está garantizada o te devolvemos tu dinero.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;